module.exports = __webpack_public_path__ + "static/media/a2@2x.ca201f2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floorplans/plans/a2@2x.png
// module id = 260
// module chunks = 0